import { PillowSDK } from './sdk.js';
export { PillowSDK } from './sdk.js';
let singleton = null;
export function init(options) {
    if (singleton) {
        if (singleton.publishableKey !== options.publishableKey) {
            throw new Error('PillowSDK.init() was called with a different publishableKey. ' +
                'Use createInstance() if you need multiple SDK instances.');
        }
        return singleton;
    }
    singleton = new PillowSDK(options);
    return singleton;
}
export function createInstance(options) {
    return new PillowSDK(options);
}
//# sourceMappingURL=index.js.map